// extracted by mini-css-extract-plugin
export default {"main":"EvaluateLayout_main__aU8eg","body":"EvaluateLayout_body__E43lu"};